import AuthenticatedRequest from 'services/requests/Authenticated';
import apiUrlConfig from 'configs/apiUrlConfig';

const URLS = {
  INDEX: `${apiUrlConfig.endPoint()}/api/admin/v1/billing_addresses/:billingId`,
  PRIMARY: `${apiUrlConfig.endPoint()}/api/admin/v1/billing_addresses/:billingId/set_primary`,
  CHARGE: `${apiUrlConfig.endPoint()}/api/admin/v1/billing_addresses/:billingId/charge_now`,
};

const insertBillingIdToUrl = (url, billingId) =>
  url.replace(':billingId', billingId);

class BillingAddressApi {
  static setPrimary(billingId) {
    const FETCH_URL = insertBillingIdToUrl(URLS.PRIMARY, billingId);
    return AuthenticatedRequest.get(FETCH_URL);
  }

  static delete(billingId) {
    const DELETE_URL = insertBillingIdToUrl(URLS.INDEX, billingId);
    return AuthenticatedRequest.delete(DELETE_URL);
  }

  static charge(billingId, data) {
    const INDEX_URL = insertBillingIdToUrl(URLS.CHARGE, billingId);
    return AuthenticatedRequest.post(INDEX_URL, data);
  }
}

export default BillingAddressApi;



// WEBPACK FOOTER //
// ./src/apis/BillingAddress.js